import React, { useState, useEffect, useContext } from 'react';
import {
  Button, Spinner, Card, InputGroup, FormControl, Modal
} from 'react-bootstrap';
import {
  FaDiceOne, FaDiceTwo, FaDiceThree, FaDiceFour, FaDiceFive, FaDiceSix,
  FaFistRaised, FaCoins, FaArrowLeft, FaHistory, FaInfoCircle,
  FaCheckCircle, FaTimesCircle
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import gameService        from '../../../services/gameService';
import { useNavigate }    from 'react-router-dom';
import { AuthContext }    from '../../../context/AuthContext';
import './MenelDuelDice.css';

/* utilidades de dados */
const ICONS = [FaDiceOne, FaDiceTwo, FaDiceThree, FaDiceFour, FaDiceFive, FaDiceSix];
const Dice  = ({ value, size = '2em' }) => {
  const Icon = ICONS[(value - 1) % 6] || FaDiceOne;
  return <Icon size={size} />;
};
const rand = () => 1 + Math.floor(Math.random() * 6);

const MenelDuelDice = () => {
  const { t }  = useTranslation();
  const nav    = useNavigate();
  const { auth } = useContext(AuthContext);
  const userId   = auth.user?.id;
  const gameId   = 15;

  /* estado */
  const [bet, setBet]           = useState(1);
  const [strategy, setStrat]    = useState('direct');
  const [pRounds, setPR]        = useState([]);
  const [hRounds, setHR]        = useState([]);
  const [res, setRes]           = useState(null);
  const [bal, setBal]           = useState(null);
  const [load, setLoad]         = useState(false);
  const [rolling, setRoll]      = useState(false);
  const [hist, setHist]         = useState([]);
  const [err, setErr]           = useState('');
  const [showRules, setRules]   = useState(false);
  const [showHist,  setShowH]   = useState(false);

  /* historial */
  useEffect(() => {
    if (!userId) return;
    (async () => {
      try {
        const h = await gameService.getPlayerHistory(userId, gameId);
        setHist(h);
      } catch { setErr(t('dueldice.errHistory')); }
    })();
  }, [userId, t]);

  /* jugar */
  const play = async () => {
    setLoad(true); setErr(''); setRes(null); setRoll(true);
    try {
      const r = await gameService.playMenelDuelDice(bet, strategy);
      setTimeout(() => {
        setPR(r.playerRounds); setHR(r.houseRounds);
        setRes(r.result);     setBal(r.newBalance);
        setLoad(false);       setRoll(false);
      }, 1800);
    } catch (e) {
      setErr(e.response?.data?.error || t('dueldice.errPlay'));
      setLoad(false); setRoll(false);
    }
  };

  /* render de cada ronda */
  const Round = ({ p, h, i }) => {
    const draw = p[0] + p[1] === h[0] + h[1];
    return (
      <div className="round-row">
        <div className={`dice-pair player-pair ${p[0]===p[1]?'dice-draw':''}`}>
          <Dice value={p[0]} /><Dice value={p[1]} />
        </div>
        <span className="versus-label">vs</span>
        <div className={`dice-pair house-pair  ${h[0]===h[1]?'dice-draw':''}`}>
          <Dice value={h[0]} /><Dice value={h[1]} />
        </div>
        <span className="round-label">
          {t('dueldice.round')} {i+1}{draw && ` (${t('dueldice.draw')})`}
        </span>
      </div>
    );
  };

  return (
    <div className="dueldice-container d-flex justify-content-center align-items-center">
      <Card className="dueldice-card text-center">
        <Button className="dueldice-back-button" onClick={()=>nav('/sessions')}>
          <FaArrowLeft />
        </Button>
        <h2 className="dueldice-title">{t('dueldice.title')}</h2>

        {/* botones reglas / historial */}
        <div className="d-flex justify-content-around my-3">
          <Button className="dueldice-button" onClick={()=>setRules(true)}>
            <FaInfoCircle /> {t('dueldice.rules')}
          </Button>
          <Button className="dueldice-button" onClick={()=>setShowH(true)}>
            <FaHistory /> {t('dueldice.history')}
          </Button>
        </div>

        {/* apuesta */}
        <InputGroup className="dueldice-bet-input-group mb-3">
          <InputGroup.Text><FaCoins /></InputGroup.Text>
          <FormControl type="number" min="1" value={bet}
                       onChange={e=>setBet(+e.target.value)} />
          <InputGroup.Text>MENEL</InputGroup.Text>
        </InputGroup>

        {/* estrategia */}
        <div className="d-flex justify-content-center gap-2 mb-3">
          <Button
            variant={strategy==='direct'?'success':'outline-success'}
            onClick={()=>setStrat('direct')}>
            {t('dueldice.direct')}
          </Button>
          <Button
            variant={strategy==='split'?'primary':'outline-primary'}
            onClick={()=>setStrat('split')}>
            {t('dueldice.split')}
          </Button>
        </div>

        {/* botones jugar / reiniciar */}
        <div className="d-flex justify-content-center gap-2 mb-3">
          <Button
            className="dueldice-play-button"
            disabled={load||rolling}
            onClick={play}>
            {load||rolling ? <Spinner animation="border" size="sm"/> :
              <><FaFistRaised/> {t('dueldice.play')}</>}
          </Button>
          <Button
            variant="danger"
            disabled={!res}
            onClick={()=>{setRes(null);setPR([]);setHR([]);setBal(null);}}>
            {t('dueldice.reset')}
          </Button>
        </div>

        {/* animación de dados chocando */}
        {rolling && (
          <div className="dice-rolling-area">
            <div className="rolling-dice player"><Dice value={rand()} size="2.6em" /></div>
            <div className="rolling-dice house" ><Dice value={rand()} size="2.6em" /></div>
          </div>
        )}

        {/* resultado global */}
        {res && (
          <div className="dueldice-result my-3">
            {res==='win'
              ? <FaCheckCircle className="dueldice-result-icon text-success" />
              : <FaTimesCircle className="dueldice-result-icon text-danger" />}
            <h4>{t(`dueldice.${res}`)}</h4>
            <p>{t('dueldice.balance')}: {bal} MENEL</p>
          </div>
        )}

        {/* lista de rondas */}
        {pRounds.length > 0 &&
          <div className="rounds-wrapper">
            {[0,1].map(i=> <Round key={i} i={i} p={pRounds[i]} h={hRounds[i]} />)}
          </div>
        }

        {err && <p className="text-danger mt-3">{err}</p>}
      </Card>

      {/* ---- Modal reglas ---- */}
      <Modal show={showRules} onHide={() => setRules(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaInfoCircle /> {t('dueldice.rules')}
          </Modal.Title>
        </Modal.Header>

        {/* renderiza la cadena HTML traducida */}
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{ __html: t('dueldice.rulesText') }}
          />
        </Modal.Body>
      </Modal>


      {/* ---- Modal historial ---- */}
      <Modal show={showHist} onHide={()=>setShowH(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title><FaHistory /> {t('dueldice.history')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight:'320px',overflowY:'auto'}}>
          {hist.length
            ? <ul className="list-group">
                {hist.map((h,i)=>(
                  <li key={i} className="list-group-item">
                    <b>{t(`dueldice.${h.result}`)}:</b> {h.score} MENEL<br/>
                    <small>{new Date(h.created_at).toLocaleString()}</small>
                  </li>
                ))}
              </ul>
            : <p>{t('dueldice.noHistory')}</p>}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MenelDuelDice;
